import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import { useState } from 'react';
import { store } from 'react-notifications-component';
import { registerBusiness } from '../../../api';

export const useRegistrationForm = () => {
  const [pending, setPending] = useState(false);
  const [registrationSuccess, setRegistrationSuccess] = useState(false);
  const [registrationData, setRegistrationData] = useState(null);
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: {
      phone: '',
      name: '',
      last_name: '',
      email: '',
      branch_name: '',
      address: '',
      phones: '',
      categories: [],
      city_id: ''
    },
    validationSchema: Yup.object({
      phone: Yup.string()
        .required(t('Form.enterPhone'))
        .min(11, t('Form.correctPhone'))
        .max(40),
      name: Yup.string()
        .required('Введите ваше имя')
        .min(2, 'Минимум 2 символа'),
      last_name: Yup.string()
        .required('Введите вашу фамилию')
        .min(2, 'Минимум 2 символа'),
      email: Yup.string()
        .email('Неверный формат email')
        .required('Введите email'),
      branch_name: Yup.string()
        .required('Введите название бизнеса')
        .min(2, 'Минимум 2 символа'),
      address: Yup.string()
        .required('Введите адрес')
        .min(5, 'Минимум 5 символов'),
      city_id: Yup.number()
        .required('Выберите город')
        .positive('Выберите город'),
      categories: Yup.array()
        .min(1, 'Выберите хотя бы одну категорию')
        .required('Выберите категорию')
    }),
    onSubmit: (async (values, { setSubmitting }) => {
      try {
        setSubmitting(true);
        setPending(true);

        // Prepare phones array - use the main phone as the phones array
        const phonesArray = values.phones ? values.phones.split(',').map(p => '+' + p.trim()) : ['+' + values.phone];

        const res = await registerBusiness({
          phone: '+' + values.phone,
          first_name: values.name,
          last_name: values.last_name,
          email: values.email,
          branch_name: values.branch_name,
          address: values.address,
          phones: phonesArray,
          categories: values.categories,
          city_id: parseInt(values.city_id)
        });

        if (res.data) {
          setRegistrationData(res.data);
          setRegistrationSuccess(true);

          store.addNotification({
            title: 'Успешная регистрация!',
            message: res.data.message || 'Регистрация прошла успешно! Проверьте вашу почту для данных авторизации.',
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 10000,
              onScreen: true
            }
          });

          setPending(false);
          return;
        }

        setPending(false);
      } catch (e) {
        const res = e.response ? e.response.data : null;

        store.addNotification({
          title: `Ошибка регистрации`,
          message: `${res ? res.message : t('Notify.notRespond')}`,
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true
          }
        });

        setPending(false);
      }
    })
  });

  return { formik, pending, registrationSuccess, registrationData };
};
